/*
 * @Author: huangshimin@klcxkj.com
 * @Date: 2022-03-28 16:17:40
 * @LastEditors: huangshimin@klcxkj.com
 * @LastEditTime: 2022-08-29 16:15:46
 * @FilePath: \app-client-h5\src\pages\home\index.jsx
 */
import React, { Component } from 'react';
import { Toast, Button } from 'antd-mobile'
import { getRoomMsg,getTemplate,getToken } from "./services";
import { PullToRefresh } from 'antd-mobile'
import { sleep } from 'antd-mobile/es/utils/sleep'
import {  GetRequest} from "../../utils/util";

import './index.scss';
let num = 1;

class Home extends Component {
    ref = React.createRef();
    formRef = React.createRef();
    constructor(props) {
        super(props)
        this.state = {
            emptyIcon:require('../../assets/nonedata.png'),
            icon:require('../../assets/addressIcon.png'),
            service: require('../../assets/service.png'),
            myIcon: require('../../assets/home-myIcon.png'),
            fail: require('../../assets/fail.png'),
            noActive: require('../../assets/noActive.png'),
            modifyIcon: require('../../assets/modifyIcon.png'),
            isNoActive:false,
            isHasnobindRoom:true,
            roomMsg:'',
            roomDetail:'',
            template:'',
            telphone:''
        }        
    }
    
    componentDidMount() {
        document.title = '趣智预付费水表';
        let appData = JSON.parse(GetRequest().data);
        console.log(appData);
        this.setState({telphone:appData.telphone});
        window.sessionStorage.setItem('telphone',appData.telphone);
        console.log(window.sessionStorage.getItem('telphone'));
        // this.getRoomMsg()
        this.getToken({
            username:appData.telphone,
            password:"587911",
            grant_type:"password",
            client_id:"quzhi-cloud",
            client_secret:"587911",
            scope:"all"
        })
    }
    getToken = (params)=>{
        getToken(params).then((res) =>{
            if (res.access_token) {
                const token = res.access_token
                window.localStorage.setItem('token', token);
                window.localStorage.setItem('isLogin', 1)
                this.getRoomMsg()
            }else{
                Toast.show({
                    content: '未获取到token',
                })
            }
                
        }).catch((err) =>{
            Toast.show({
                content: '未获取到token',
            })
        })
    }
    getRoomMsg = ()=>{
        getRoomMsg().then((res) =>{
            if (res.code == '200') {
                if (!res.data) {
                    if (localStorage.getItem('roomData')) {
                        localStorage.removeItem('roomData');
                    }
                    this.setState({isHasnobindRoom:true});
                    return;
                }
                let wakeFreq2 = '7天';
                switch (res.data.wakeFreq) {
                    case 1:
                        wakeFreq2 = '12小时';
                        break;
                    case 2:
                        wakeFreq2 = '1天';
                        break;
                    case 3:
                        wakeFreq2 = '2天';
                        break;
                    case 4:
                        wakeFreq2 = '3天';
                        break;
                    case 5:
                        wakeFreq2 = '7天';
                        break;
                    case 6:
                        wakeFreq2 = '10天';
                        break;
                    case 7:
                        wakeFreq2 = '15天';
                        break;
                    case 8:
                        wakeFreq2 = '1月';
                        break;
                    default:
                        wakeFreq2 = '7天';
                }
                res.data.wakeFreq2 = wakeFreq2;
                const roomAndfre = {
                    frequency: res.data.wakeFreq,
                    room: res.data.areaName+res.data.buildingName + res.data.floorName + res.data.roomName,
                    projectName: res.data.projectName,
                    updataTime: res.data.uploadTime,
                    estimatedExecTime: res.data.estimatedExecTime,
                    projectId: res.data.projectId,
                    roomId: res.data.roomId
                }
                
                this.setState({
                    isHasnobindRoom:false,
                    roomMsg:res.data,
                    roomDetail:res.data.areaName+res.data.buildingName + res.data.floorName + res.data.roomName
                })
                localStorage.setItem('roomData',JSON.stringify(roomAndfre))
            }else{
                if (localStorage.getItem('roomData')) {
                    localStorage.removeItem('roomData');
                }
                Toast.show({
                    content: res.message,
                })
            }
        }).catch((err) =>{
            Toast.show({
                content: '系统错误',
            })
        })
    }
    buyWater = () => {
        getTemplate().then((res) =>{
            if (res.code == '200') {
                if (!res.data) {
                    Toast.show({
                        content: '该房间未设置水费模板，无法买水',
                    })
                    return;
                }
                
                this.props.history.push('/rechargeWater')
            }else{
                Toast.show({
                    content: res.message,
                })
            }
        }).catch((err) =>{
            Toast.show({
                content: '系统错误',
            })
        })
    }
    checkWaterUse = () => {
        this.props.history.push('/waterUseRecord')
    }
    gotoMy = () => {
        this.props.history.push('/my')
    }
    gotoBindRoom = () => {
        this.props.history.push('/bindRoom')
    }
    goBuyWaterOrder = () => {
        this.props.history.push('/orderList')
    }
    changeRoom = () => {
        this.props.history.push('/bindRoom?formPage=my')
    }
    renderTopBox() {
        const {icon ,noActive,modifyIcon,roomMsg} = this.state;
        const { projectName,areaName,buildingName,floorName,roomName,elecPercent,valueStatus,wakeFreq,wakeDesc,wakeFreq2,wakeDay,wakeHours} = roomMsg;
        return (
            <div className='top-box'>
                <div className='top-box_header'>
                    <img className = 'icon' src={icon} />
                    <span>{projectName||'--'}<span className= 'verLine'>|</span>{(areaName+buildingName+floorName+roomName)||'--'}</span> 
                    <img className='modifyIcon' src={modifyIcon} onClick={this.changeRoom} />
                </div>
                
                {elecPercent!=null&&valueStatus!=null&&wakeFreq!=null?
                <div className='top-box-content'>
                    <div>
                        <span className='title'>水表电量</span>
                        <div className='tetx'>{elecPercent}%</div>
                    </div>
                    <div>
                        <span className='title'>水表阀</span>
                        <div className='tetx'>{valueStatus==0?'开':'关'}</div>
                    </div>
                    <div>
                        <span className='title'>数据更新频率</span>
                        <div className='tetx'>
                            {/* <span>{wakeDesc}</span> */}
                            <span>{wakeFreq2}/次{wakeFreq2=='12小时'?"":';'}</span>
                            {wakeDay?<span>每月{wakeDay}号</span>:''}
                            { wakeFreq2!='12小时'?(wakeHours == 0 || wakeHours ? <span className='value'>{wakeHours}点</span>:''):''}
                        </div>
                    </div>
                </div>
                :
                <div className='top-box-content-none'>
                    <img src={noActive}/>
                    <div>暂无激活设备</div>
                </div>}
            </div>
        )
    }
    renderMiddleBox() {
        const {roomMsg} = this.state;
        const { remainWater,uploadTime} = roomMsg;
        return (
            <div className='middle-box'>
                <div className='remain'>房间剩余水量</div>
                <div className='number'>
                    <span>{remainWater}</span>
                    <span>吨</span>
                </div>
                <div className='time'>更新时间：<span>{uploadTime||'- -'}</span></div>
            </div>
        )
    }
    renderBtnbox() {
        return (
            <div className = 'btn-box'>
                <Button className = 'check-btn'  shape='rounded' color='primary' fill='outline' onClick={this.checkWaterUse}>查看房间用水明细</Button>
                <Button className = 'buy-btn'  shape='rounded' color = '' onClick={this.buyWater}>买水</Button>
            </div>
        )
    }
    renderBubble() {
        const {myIcon} = this.state;
        return (
            <div className = 'bubble-box'>
                <img className = 'myIcon' src={myIcon} onClick = {this.gotoMy}/>
            </div>
        )
    }
    renderService() {
        const {service,roomMsg} = this.state;
        const { prjConnectPhone } = roomMsg;
        return (
            <div className='service-box'>
                <img src={service} alt="" />
                <span>项目客服：<a href={"tel://"+prjConnectPhone}>{prjConnectPhone|| '--'}</a></span>
            </div>
        )
    }
    
    renderEmpty() {
        return (
            <div>
                <div>
                    <img className = 'emptyIcon' src = {this.state.emptyIcon}/>
                </div>
                <div className = 'text'>您还未绑定任何房间，请绑定房间</div>
                <div>
                    <Button className = 'bindRoombtn' shape='rounded' color='' onClick={this.gotoBindRoom}>绑定房间</Button>
                </div>
            </div>
        )
    }
    render() {
        const { isHasnobindRoom ,telphone} = this.state;
        return (
            <div className='home-container'>
                {isHasnobindRoom?<div className='emptyBox' >
                    {this.renderEmpty()}
                    {/* {this.renderBubble()} */}
                </div>:
                <div className = 'normal' >
                    {this.renderTopBox()}
                    {this.renderMiddleBox()}
                    {this.renderBtnbox()}
                    <div className= 'buyWaterOrder' onClick={this.goBuyWaterOrder}>我的买水订单</div>
                    {/* {this.renderBubble()} */}
                    {this.renderService()}
                </div>
                }
            </div>
        )
    }
}
export default Home;

